import axios from "axios";
import axiosInstance from "@/lib/axios";
import type { CatalogQueryParams, CatalogResponse, TagFilterResponse } from "@/types/catalog";
import type { ApiErrorResponse } from "@/types/apierror";

const CATALOG_URL = "/catalog";
const TAG_FILTER_URL = "/tags/filter";

export async function getCatalog(params?: CatalogQueryParams): Promise<CatalogResponse> {
  try {
    const { data } = await axiosInstance.get<CatalogResponse>(CATALOG_URL, {
      params,
      paramsSerializer: (currentParams) => {
        const searchParams = new URLSearchParams();

        Object.entries(currentParams ?? {}).forEach(([key, value]) => {
          if (value === undefined || value === null) return;

          if (Array.isArray(value)) {
            value.forEach((item) => {
              searchParams.append(key, String(item));
            });
            return;
          }

          searchParams.append(key, String(value));
        });

        return searchParams.toString();
      },
      withCredentials: true,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
}

export async function getTagFilters(): Promise<TagFilterResponse> {
  try {
    const { data } = await axiosInstance.get<TagFilterResponse>(TAG_FILTER_URL, {
      withCredentials: true,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
}
